import { Alert, Stack, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

/** Retired: schema-based AI forms were replaced by page-based forms. */
export const Schemas = () => {
  const { t } = useTranslation('ai')
  return (
    <Stack gap="md">
      <Alert color="blue" title={t('schema_editor.retired_title', { defaultValue: 'Schema forms retired' })}>
        <Text size="sm">
          {t('schema_editor.retired_body', {
            defaultValue:
              'AI prompt schemas are no longer used. Tenants create and publish forms as document pages (page_type = form) with form_field elements. Historical protocoll_form_submissions remain in the database for audit.'
          })}
        </Text>
      </Alert>
    </Stack>
  )
}
